import { stopSubmit, change, arrayRemove } from 'redux-form';

import * as SagasType from '../constants/constant_saga_types';
import * as ActionType from '../constants/constant_action_types';

export * from './actionCreatorsInitialize';
export { dropdownFetchListInProgress, dropdownFetchListDone, dropdownFetchError, dropdownFetchMountAll } from '../components/common/form/fields/dropdown_search';

export function processCSVImport(data) {
  return { type: 'PROCESS_CSV_IMPORT', payload: data };
}

export function applyIntl(intl) {
  return { type: ActionType.APPLY_INTL, intl };
}

export function saveSubsidiary(data) {
  return { type: 'SAVE_SUBSIDIARY', data };
}

export function saveExchangeRate(data) {
  return { type: 'SAVE_EXCHANGE_RATE', data };
}

export function saveReportingExchangeRate(data) {
  return { type: 'SAVE_REPORTING_EXCHANGE_RATE', data };
}

export function saveCashRounding(data) {
  return { type: 'SAVE_CASH_ROUNDING', data };
}

export function saveAddressType(data, intl) {
  return { type: 'SAVE_ADDRESS_TYPE', data, intl };
}

export function saveCurrency(data) {
  return { type: 'SAVE_CURRENCY', data };
}

export function saveClassification(data) {
  return { type: 'SAVE_CLASSIFICATION', data };
}

export function saveCSVRecord(data) {
  return { type: 'SAVE_CSV_RECORD', data };
}

export function saveAndImportCSVRecord(data) {
  return { type: 'SAVE_IMPORT_CSV_RECORD', data };
}

export function saveRoles(data) {
  return { type: 'SAVE_ROLES', data };
}

export function saveDeviceType(data) {
  return { type: 'SAVE_DEVICE_TYPE', data };
}

export function savePriceLevel(data) {
  return { type: 'SAVE_PRICE_LEVEL', data };
}

export function saveReasonCode(data) {
  return { type: 'SAVE_REASON_CODE', data };
}

export function saveTaskType(data) {
  return { type: 'SAVE_TASK_TYPE', data };
}

export function saveSeason(data) {
  return { type: 'SAVE_SEASON', data };
}

export function saveGroupType(data) {
  return { type: 'SAVE_GROUP_TYPE', data };
}

export function saveCreditType(data) {
  return { type: 'SAVE_CREDIT_TYPE', data };
}

export function saveCountry(data) {
  return { type: 'SAVE_COUNTRY', data };
}

export function saveRelatedEntityType(data) {
  return { type: 'SAVE_RELATED_ENTITY_TYPE', data };
}

export function deleteDeviceTypeFromList(id) {
  return { type: 'DELETE_DEVICE_TYPE_FROM_LIST', id };
}

export function deleteClassificationFromList(id) {
  return { type: 'DELETE_CLASSIFICATION_FROM_LIST', id };
}

export function deleteRolesFromList(id) {
  return { type: 'DELETE_ROLES_FROM_LIST', id };
}

export function deletePriceLevelFromList(id) {
  return { type: 'DELETE_PRICE_LEVEL_FROM_LIST', id };
}

export function deleteReasonCodeFromList(id) {
  return { type: 'DELETE_REASON_CODE_FROM_LIST', id };
}

export function deleteItem(id) {
  return { type: "DELETE_ITEM", id };
}
export function deleteItemFromList(id) {
  return { type: "DELETE_ITEM_FROM_LIST", id };
}

export function deleteContactFromList(id) {
  return { type: "DELETE_CONTACT_FROM_LIST", id };
}

export function deletePriceBook(id) {
  return { type: "DELETE_PRICEBOOK", id };
}

export function deleteRelatedEntityType(id) {
  return { type: "DELETE_RELATED_ENTITY_TYPE", id };
}

export function deletePriceBookFromList(id) {
  return { type: "DELETE_PRICEBOOK_FROM_LIST", id };
}

export function deleteCustomer(id, fromList) {
  return { type: 'DELETE_CUSTOMER', id, fromList };
}

export function deleteSupplier(id, fromList) {
  return { type: 'DELETE_SUPPLIER', id, fromList };
}

export function deleteEmployee(id, fromList) {
  return { type: 'DELETE_EMPLOYEE', id, fromList };
}

export function deletePaymentType(id, fromList) {
  return { type: 'DELETE_PAYMENT_TYPE', id, fromList };
}

export function deleteIntegration(id, fromList) {
  return { type: 'DELETE_INTEGRATION', id, fromList };
}

export function deleteContact(id, fromList) {
  return { type: 'DELETE_CONTACT', id, fromList };
}

export function deleteClassification(id, fromList) {
  return { type: 'DELETE_CLASSIFICATION', id, fromList };
}


export function deleteCSVRecord(id, fromList) {
  return { type: 'DELETE_CSV_RECORD', id, fromList };
}

// export function deleteIntegrationApp(id, fromList) {
//   return { type: 'DELETE_INTEGRATION_APP', id, fromList };
// }

export function deleteRoles(id, fromList) {
  return { type: 'DELETE_ROLES', id, fromList };
}

export function getListData(docType, query, paginate) {
  return { type: 'FETCH_LIST_DATA', docType, query, paginate };
}

export function getItemForEdit(id) {
  return { type: 'FETCH_ITEM_FOR_EDIT', id };
}

export function getPriceBookForEdit(id) {
  return { type: 'FETCH_PRICEBOOK_FOR_EDIT', id };
}

export function getPriceBookForRenew(id) {
  return { type: 'FETCH_PRICEBOOK_FOR_RENEW', id };
}

export function getClassificationForEdit(id) {
  return { type: 'FETCH_CLASSIFICATION_FOR_EDIT', id };
}

export function getCSVRecordForEdit(id) {
  return { type: 'FETCH_CSV_RECORD_FOR_EDIT', id };
}

export function getRolesForEdit(id) {
  return { type: 'FETCH_ROLES_FOR_EDIT', id };
}

export function fetchItemList(filters, silent) {
  return { type: 'FETCH_LIST_ITEM', filters, silent };
}

export function getCustomerForEdit(id) {
  return { type: 'FETCH_CUSTOMER_FOR_EDIT', id };
}

export function getLocationForEdit(id) {
  return { type: 'FETCH_LOCATION_FOR_EDIT', id };
}

export function fetchCustomerList(filters, silent) {
  return { type: 'FETCH_LIST_CUSTOMERS', filters, silent };
}

export function fetchSupplierList(filters, silent) {
  return { type: 'FETCH_LIST_SUPPLIERS', filters, silent };
}

export function fetchEmployeeList(filters, silent) {
  return { type: 'FETCH_LIST_EMPLOYEES', filters, silent };
}

export function fetchPaymentTypeList(filters, silent) {
  return { type: 'FETCH_LIST_PAYMENT_TYPE', filters, silent };
}

export function fetchIntegrationList(filters, silent) {
  return { type: 'FETCH_LIST_INTEGRATIONS', filters, silent };
}

export function fetchContactList(filters, silent) {
  return { type: 'FETCH_LIST_CONTACT', filters, silent };
}

export function fetchCurrencyList(silent, filters) {
  return { type: 'FETCH_LIST_CURRENCY', silent, filters };
}

export function fetchAddressTypeList(silent, filters) {
  return { type: 'FETCH_LIST_ADDRESS_TYPE', silent, filters };
}

export function fetchAddressTypeById(id) {
  return { type: 'FETCH_ADDRESS_TYPE_BY_ID', id };
}

export function fetchRelatedEntityTypeList(silent, filters) {
  return { type: 'FETCH_LIST_RELATED_ENTITY_TYPE', silent, filters };
}

export function fetchRelatedEntityTypeById(id) {
  return { type: 'FETCH_RELATED_ENTITY_TYPE_BY_ID', id };
}

export function findTransactionByLocation(id) {
  return { type: 'FIND_TRANSACTION_BY_LOCATION', id };
}

export function getDataById(docType, id) {
  return { type: 'FETCH_DATA_BY_ID', docType, id };
}

export function getEmployeeForEdit(id) {
  return { type: 'FETCH_EMPLOYEE_FOR_EDIT', id };
}

export function getSupplierForEdit(id) {
  return { type: 'FETCH_SUPPLIER_FOR_EDIT', id };
}

export function getPaymentTypeForEdit(id) {
  return { type: 'FETCH_PAYMENT_TYPE_FOR_EDIT', id };
}

export function getIntegrationForEdit(id) {
  return { type: 'FETCH_INTEGRATION_FOR_EDIT', id };
}

export function fetchClassificationList(filters, silent) {
  return { type: 'FETCH_LIST_CLASSIFICATION', filters, silent };
}

export function fetchCSVRecordList(filters, silent) {
  return { type: 'FETCH_LIST_CSV_RECORD', filters, silent };
}

export function fetchRolesList(filters, silent) {
  return { type: 'FETCH_LIST_ROLES', filters, silent };
}

export function clearDataById(docType, id) {
  return { type: 'CLEAR_DATA_BY_ID', docType, id };
}

export function saveLocation(data) {
  return { type: 'SAVE_LOCATION', data };
}

export function saveItem(data, intl) {
  return { type: 'SAVE_ITEM', data, intl };
}

export function savePriceBook(data, isRenew, previousId) {
  return { type: 'SAVE_PRICE_BOOK', data, isRenew, previousId };
}

export function fetchPriceBookList(filters, silent) {
  return { type: 'FETCH_LIST_PRICEBOOK', filters, silent };
}

export function saveItemLocation(data) {
  return { type: 'SAVE_ITEM_LOCATION', data };
}

export function saveCustomer(data) {
  return { type: 'SAVE_CUSTOMER', data };
}

export function saveEmployee(data) {
  return { type: 'SAVE_EMPLOYEE', data };
}

export function savePaymentType(data) {
  return { type: 'SAVE_PAYMENT_TYPE', data };
}

export function saveSupplier(data) {
  return { type: 'SAVE_SUPPLIER', data };
}

export function saveContact(data) {
  return { type: 'SAVE_CONTACT', data };
}

export function saveHotkeyGroup(data, items) {
  return { type: 'SAVE_HOTKEY_GROUP', data, items };
}

export function saveFacet(data) {
  return { type: 'SAVE_FACET', data };
}

export function fetchDeviceTypeList(silent, filters) {
  return { type: 'FETCH_LIST_DEVICE_TYPE', silent, filters };
}

export function fetchDeviceTypeById(id) {
  return { type: 'FETCH_DEVICE_TYPE_BY_ID', id };
}

export function fetchExchangeRateList(filters, silent) {
  return { type: 'FETCH_LIST_EXCHANGE_RATE', filters, silent };
}

export function fetchReportingExchangeRateList(filters, silent) {
  return { type: 'FETCH_LIST_REPORTING_EXCHANGE_RATE', filters, silent };
}

export function fetchCashRoundingList(silent, filters) {
  return { type: 'FETCH_LIST_CASH_ROUNDING', silent, filters };
}

export function fetchCashRoundingById(id) {
  return { type: 'FETCH_CASH_ROUNDING_BY_ID', id };
}

export function fetchPriceLevelList(silent, filters) {
  return { type: 'FETCH_LIST_PRICE_LEVEL', silent, filters };
}

export function fetchPriceLevelById(id) {
  return { type: 'FETCH_PRICE_LEVEL_BY_ID', id };
}

export function fetchReasonCodeList(silent, filters) {
  return { type: 'FETCH_LIST_REASON_CODE', silent, filters };
}

export function fetchTaskTypeList(silent, filters) {
  return { type: 'FETCH_LIST_TASK_TYPE', silent, filters };
}

export function fetchTaskTypeById(id) {
  return { type: 'FETCH_TASK_TYPE_BY_ID', id };
}

export function fetchSeasonList(silent, filters) {
  return { type: 'FETCH_LIST_SEASON', silent, filters };
}

export function fetchGroupTypeList(silent, filters) {
  return { type: 'FETCH_LIST_GROUP_TYPE', silent, filters };
}

export function fetchCreditTypeList(silent, filters) {
  return { type: 'FETCH_LIST_CREDIT_TYPE', silent, filters };
}

export function fetchCreditTypeById(id) {
  return { type: 'FETCH_CREDIT_TYPE_BY_ID', id };
}

export function fetchCountryList(silent, filters) {
  return { type: 'FETCH_LIST_COUNTRY', filters, silent };
}

export function fetchCountryById(id) {
  return { type: 'FETCH_COUNTRY_BY_ID', id };
}

export function fetchFacetList(silent, filters) {
  return { type: 'FETCH_LIST_FACET', silent, filters };
}

export function fetchFacetById(id) {
  return { type: 'FETCH_FACET_BY_ID', id };
}

export function deleteCurrencyFromList(id) {
  return { type: "DELETE_CURRENCY_FROM_LIST", id };
}

export function deleteAddressTypeFromList(id) {
  return { type: "DELETE_ADDRESS_TYPE_FROM_LIST", id };
}

export function deleteCashRoundingFromList(id) {
  return { type: "DELETE_CASH_ROUNDING_FROM_LIST", id };
}

export function deleteTaskTypeFromList(id) {
  return { type: "DELETE_TASK_TYPE_FROM_LIST", id };
}

export function deleteSeasonFromList(id) {
  return { type: "DELETE_SEASON_FROM_LIST", id };
}

export function deleteCreditTypeFromList(id) {
  return { type: "DELETE_CREDIT_TYPE_FROM_LIST", id };
}

export function deleteCountryFromList(id) {
  return { type: "DELETE_COUNTRY_FROM_LIST", id };
}

export function deleteFacetFromList(id) {
  return { type: "DELETE_FACET_FROM_LIST", id };
}

export function deleteCustomerFromList(id) {
  return { type: "DELETE_CUSTOMER_FROM_LIST", id };
}

export function deleteEmployeeFromList(id) {
  return { type: "DELETE_EMPLOYEE_FROM_LIST", id };
}

export function deletePaymentTypeFromList(id) {
  return { type: "DELETE_PAYMENT_TYPE_FROM_LIST", id };
}

export function deleteIntegrationFromList(id) {
  return { type: "DELETE_INTEGRATION_FROM_LIST", id };
}

export function deleteSupplierFromList(id) {
  return { type: "DELETE_SUPPLIER_FROM_LIST", id };
}


export function deletAddressType(id) {
  return { type: "DELETE_ADDRESS_TYPE", id };
}

export function deleteDeviceType(id) {
  return { type: "DELETE_DEVICE_TYPE", id };
}

export function deleteCashRounding(id) {
  return { type: "DELETE_CASH_ROUNDING", id };
}

export function deletePriceLevel(id) {
  return { type: "DELETE_PRICE_LEVEL", id };
}

export function deleteReasonCode(id) {
  return { type: "DELETE_REASON_CODE", id };
}

export function deleteTaskType(id) {
  return { type: "DELETE_TASK_TYPE", id };
}

export function deleteSeason(id) {
  return { type: "DELETE_SEASON", id };
}

export function deleteGroupType(id) {
  return { type: "DELETE_GROUP_TYPE", id };
}

export function deleteCreditType(id) {
  return { type: "DELETE_CREDIT_TYPE", id };
}

export function deleteCountry(id) {
  return { type: "DELETE_COUNTRY", id };
}

export function deleteFacet(id) {
  return { type: "DELETE_FACET", id };
}


export function deleteExchangeRate(id) {
  return { type: "DELETE_EXCHANGE_RATE", id };
}

export function deleteReportingExchangeRate(id) {
  return { type: "DELETE_REPORTING_EXCHANGE_RATE", id };
}

export function deleteCurrency(id) {
  return { type: "DELETE_CURRENCY", id };
}


export function deleteRelatedEntityTypeFromList(id) {
  return { type: "DELETE_RELATED_ENTITY_TYPE", id };
}


export function getDeviceTypeForEdit(id) {
  return { type: 'FETCH_DEVICE_TYPE_BY_ID', id };
}

export function getAddressTypeForEdit(id) {
  return { type: 'FETCH_ADDRESS_TYPE_BY_ID', id };
}

export function getCurrencyForEdit(id) {
  return { type: 'FETCH_CURRENCY_BY_ID', id };
}

export function getTaskTypeForEdit(id) {
  return { type: 'FETCH_TASK_TYPE_BY_ID', id };
}

export function getSeasonForEdit(id) {
  return { type: 'FETCH_SEASON_BY_ID', id };
}

export function getGroupTypeForEdit(id) {
  return { type: 'FETCH_GROUP_TYPE_BY_ID', id };
}

export function getCreditTypeForEdit(id) {
  return { type: 'FETCH_CREDIT_TYPE_BY_ID', id };
}

export function getContactForEdit(id) {
  return { type: 'FETCH_CONTACT_FOR_EDIT', id };
}

export function getPriceLevelForEdit(id) {
  return { type: 'FETCH_PRICE_LEVEL_BY_ID', id };
}

export function getRelatedEntityTypeForEdit(id) {
  return { type: 'FETCH_RELATED_ENTITY_TYPE_BY_ID', id };
}

export function getItemLocListByItemId(docType, itemId) {
  return { type: 'FETCH_LIST_ITEM_LOC_BY_ITEMID', itemId };
}

export function clearFormMessages() {
  return { type: 'CLEAR_FORM_MESSAGES' }
}

export function fetchSubsidiaryList(filters, silent) {
  return { type: 'FETCH_LIST_SUBSIDIARY', filters, silent };
}

export function getSubsidiaryForEdit(id) {
  return { type: 'FETCH_SUBSIDIARY_FOR_EDIT', id };
}

export function deleteSubsidiaryFromList(id) {
  return { type: "DELETE_SUBSIDIARY_FROM_LIST", id };
}

export function deleteSubsidiary(id) {
  return { type: "DELETE_SUBSIDIARY", id };
}

export function fetchLocationList(filters, silent) {
  return { type: 'FETCH_LIST_LOCATION', filters, silent };
}

export function deleteLocationFromList(id) {
  return { type: "DELETE_LOCATION_FROM_LIST", id };
}

export function deleteLocation(id) {
  return { type: "DELETE_LOCATION", id };
}

export function getHotKeyGroupForEdit(id) {
  return { type: 'FETCH_HOTKEY_GROUP_BY_ID', id };
}

export function getHotkeyTemplateForEdit(id) {
  return { type: 'FETCH_HOTKEY_TEMPLATE_BY_ID', id };
}

export function fetchHotkeyGroupList(silent, filters) {
  return { type: 'FETCH_LIST_HOTKEY_GROUP', silent, filters };
}

export function fetchHotkeyTemplateList(silent, filters) {
  return { type: 'FETCH_LIST_HOTKEY_TEMPLATE', silent, filters };
}


export function deleteHotkeyGroupFromList(id) {
  return { type: "DELETE_HOTKEY_GROUP_FROM_LIST", id }
}

export function deleteHotkeyTemplateFromList(id) {
  return { type: "DELETE_HOTKEY_TEMPLATE_FROM_LIST", id }
}

export function deleteHotkeyGroup(id) {
  return { type: "DELETE_HOTKEY_GROUP", id };
}

export function deleteHotkeyTemplate(id) {
  return { type: "DELETE_HOTKEY_TEMPLATE", id };
}

export function fetchProductTypeList({ intl }) {
  return { type: "FETCH_LIST_PRODUCT_TYPES", intl };
}

export function addErrorMessages(messages) {
  return { type: "ADD_ERROR_MESSAGES", messages };
}

export function saveAs(id, docType, saveAsUrl, intl) {
  return { type: "SAVE_RECORD_AS", id, docType, saveAsUrl, intl };
}

export function fetchTaxCodeList(filters, silent) {
  return { type: 'FETCH_LIST_TAXCODE', filters, silent };
}

export function getTaxCodeForEdit(id) {
  return { type: 'FETCH_TAXCODE_FOR_EDIT', id };
}

export function saveTaxCode(data) {
  return { type: 'SAVE_TAXCODE', data };
}

export function deleteTaxCodeFromList(id) {
  return { type: "DELETE_TAXCODE_FROM_LIST", id };
}

export function deleteTaxCode(id) {
  return { type: "DELETE_TAXCODE", id };
}


export function saveTaxExemptType(data) {
  return { type: 'SAVE_TAX_EXEMPT_TYPE', data };
}

export function fetchTaxExemptTypeList(silent, filters) {
  return { type: 'FETCH_LIST_TAX_EXEMPT_TYPE', silent, filters };
}

export function fetchTaxExemptTypeById(id) {
  return { type: 'FETCH_TAX_EXEMPT_TYPE_BY_ID', id };
}

export function deleteTaxExemptTypeFromList(id) {
  return { type: "DELETE_TAX_EXEMPT_TYPE_FROM_LIST", id }
}

export function deleteTaxExemptType(id) {
  return { type: "DELETE_TAX_EXEMPT_TYPE", id };
}

export function getTaxExemptTypeForEdit(id) {
  return { type: 'FETCH_TAX_EXEMPT_TYPE_BY_ID', id };
}


export function saveTaxType(data) {
  return { type: 'SAVE_TAX_TYPE', data };
}

export function fetchTaxTypeList(silent, filters) {
  return { type: 'FETCH_LIST_TAX_TYPE', silent, filters };
}

export function fetchTaxTypeById(id) {
  return { type: 'FETCH_TAX_TYPE_BY_ID', id };
}

export function deleteTaxTypeFromList(id) {
  return { type: "DELETE_TAX_TYPE_FROM_LIST", id }
}

export function deleteTaxType(id) {
  return { type: "DELETE_TAX_TYPE", id };
}

export function getTaxTypeForEdit(id) {
  return { type: 'FETCH_TAX_TYPE_BY_ID', id };
}


export function saveTaxGroup(data) {
  return { type: 'SAVE_TAX_GROUP', data };
}

export function fetchTaxGroupList(silent, filters) {
  return { type: 'FETCH_LIST_TAX_GROUP', silent, filters };
}

export function fetchTaxGroupById(id) {
  return { type: 'FETCH_TAX_GROUP_BY_ID', id };
}

export function deleteTaxGroupFromList(id) {
  return { type: "DELETE_TAX_GROUP_FROM_LIST", id };
}

export function deleteTaxGroup(id) {
  return { type: "DELETE_TAX_GROUP", id };
}

export function getTaxGroupForEdit(id) {
  return { type: 'FETCH_TAX_GROUP_BY_ID', id };
}


export function saveBrand(data) {
  return { type: 'SAVE_BRAND', data };
}

export function fetchBrandList(silent, filters) {
  return { type: 'FETCH_LIST_BRAND', silent, filters };
}

export function fetchBrandById(id) {
  return { type: 'FETCH_BRAND_BY_ID', id };
}

export function deleteBrandFromList(id) {
  return { type: "DELETE_BRAND_FROM_LIST", id };
}

export function deleteBrand(id) {
  return { type: "DELETE_BRAND", id };
}

export function getBrandForEdit(id) {
  return { type: 'FETCH_BRAND_BY_ID', id };
}


export function fetchMatrixAttributeList(silent, filters) {
  return { type: 'FETCH_LIST_MATRIX_ATTRIBUTE', silent, filters };
}

export function getMatrixAttributeForEdit(id) {
  return { type: 'FETCH_MATRIX_ATTRIBUTE_FOR_EDIT', id };
}

export function saveMatrixAttribute(data) {
  return { type: 'SAVE_MATRIX_ATTRIBUTE', data };
}

export function deleteMatrixAttributeFromList(id) {
  return { type: "DELETE_MATRIX_ATTRIBUTE_FROM_LIST", id };
}

export function deleteMatrixAttribute(id) {
  return { type: "DELETE_MATRIX_ATTRIBUTE", id };
}

export function getPreferenceSettings(settings, subsidiaryId, locationId) {
  return { type: SagasType.FETCH_PREFERENCES_SETTINGS, settings, subsidiaryId, locationId };
}

export function setCurrencyContent(currencyId) {
  return { type: ActionType.SET_CURRENCY_CONTENT, id: currencyId };
}

export function clearCurrencyContent() {
  return { type: ActionType.CLEAR_CURRENCY_CONTENT };
}

export function getMatrixDetailForEdit(id) {
  return { type: 'FETCH_MATRIX_DETAIL_FOR_EDIT', id };
}

export function generateMatrixItems(matrixData) {
  return { type: 'GENERATE_MATRIX_ITEMS', matrixData };
}

export function getMatrixCombination(attributeList) {
  return { type: 'GET_MATRIX_COMBINATION', attributeList };
}

export function saveAttributeName(data) {
  return { type: 'SAVE_ATTRIBUTE_NAME', data };
}

export function fetchAttributeNameList(silent, filters) {
  return { type: 'FETCH_LIST_ATTRIBUTE_NAME', silent, filters };
}

export function fetchAttributeNameById(id) {
  return { type: 'FETCH_ATTRIBUTE_NAME_BY_ID', id };
}

export function deleteAttributeNameFromList(id) {
  return { type: "DELETE_ATTRIBUTE_NAME_FROM_LIST", id };
}

export function deleteAttributeName(id) {
  return { type: "DELETE_ATTRIBUTE_NAME", id };
}

export function getAttributeNameForEdit(id) {
  return { type: 'FETCH_ATTRIBUTE_NAME_BY_ID', id };
}


export function saveAttributeValue(data) {
  return { type: 'SAVE_ATTRIBUTE_VALUE', data };
}

export function fetchAttributeValueList(silent, filters) {
  return { type: 'FETCH_LIST_ATTRIBUTE_VALUE', silent, filters };
}

export function fetchAttributeValueById(id) {
  return { type: 'FETCH_ATTRIBUTE_VALUE_BY_ID', id };
}

export function deleteAttributeValueFromList(id) {
  return { type: "DELETE_ATTRIBUTE_VALUE_FROM_LIST", id };
}

export function deleteAttributeValue(id) {
  return { type: "DELETE_ATTRIBUTE_VALUE", id };
}

export function getAttributeValueForEdit(id) {
  return { type: 'FETCH_ATTRIBUTE_VALUE_BY_ID', id };
}

export function savePromotion(data) {
  return { type: 'SAVE_PROMOTION', data };
}

export function fetchPromotionList(filters, silent) {
  return { type: 'FETCH_LIST_PROMOTION', filters, silent };
}

export function deletePromotion(id) {
  return { type: "DELETE_PROMOTION", id };
}

export function deletePromotionFromList(id) {
  return { type: "DELETE_PROMOTION_FROM_LIST", id };
}

export function getPromotionForEdit(id) {
  return { type: 'FETCH_PROMOTION_FOR_EDIT', id };
}

export function getTaxesByTaxGroup(id) {
  return { type: SagasType.GET_PRICEBOOK_TAX_CODE, tax_group_id: id };
}

export function saveTask(data) {
  return { type: 'SAVE_TASK', data };
}

export function getTaskForEdit(id) {
  return { type: 'FETCH_TASK_FOR_EDIT', id };
}

export function fetchTaskList(filters, silent) {
  return { type: 'FETCH_TASK_LIST', filters, silent };
}

export function deleteTask(id) {
  return { type: 'DELETE_TASK', id };
}

export function getExchangeRateForEdit(id) {
  return { type: 'FETCH_EXCHANGE_RATE_FOR_EDIT', id };
}

export function getReportingExchangeRateForEdit(id) {
  return { type: 'FETCH_REPORTING_EXCHANGE_RATE_FOR_EDIT', id };
}

export function fetchShiftTypeList(silent, filters) {
  return { type: SagasType.FETCH_LIST_SHIFT_TYPE, silent, filters };
}

export function saveShiftType(data) {
  return { type: SagasType.SAVE_SHIFT_TYPE, data };
}

export function deleteShiftType(id) {
  return { type: SagasType.DELETE_SHIFT_TYPE, id };
}

export function fetchShiftTypeById(id) {
  return { type: SagasType.FETCH_SHIFT_TYPE_BY_ID, id };
}

export function fetchItemNumberTypeList(silent, filters) {
  return { type: SagasType.FETCH_LIST_ITEM_NUMBER_TYPE, silent, filters };
}

export function saveItemNumberType(data) {
  return { type: SagasType.SAVE_ITEM_NUMBER_TYPE, data };
}

export function deleteItemNumberType(id) {
  return { type: SagasType.DELETE_ITEM_NUMBER_TYPE, id };
}

export function fetchItemNumberTypeById(id) {
  return { type: SagasType.FETCH_ITEM_NUMBER_TYPE_BY_ID, id };
}

export function fetchRegionList(silent, filters) {
  return { type: 'FETCH_REGION_LIST', silent, filters };
}

export function saveRegion(data) {
  return { type: 'SAVE_REGION', data };
}

export function getRegionForEdit(id) {
  return { type: 'FETCH_REGION_FOR_EDIT', id };
}

export function deleteRegion(id) {
  return { type: "DELETE_REGION", id }
}

export function employeeChangePassword(email) {
  return { type: 'EMPLOYEE_CHANGE_PASS', email };
}

export function employeeChangePin(employeeId) {
  return { type: 'EMPLOYEE_CHANGE_PIN', employeeId };
}

export function employeeEmailPin(id) {
  return { type: 'EMPLOYEE_EMAIL_PIN', payload: id };
}

export function employeeSmsPin(id) {
  return { type: 'EMPLOYEE_SMS_PIN', payload: id };
}

export function clearDropdown(key) {
  return { type: ActionType.CLEAR_DROPDOWN, id: key };
}

export function clearGlobalFormError(form) {
  return stopSubmit(form, {});
}

export function setTableOptions(options) {
  return { type: ActionType.SET_LIST_TABLE_OPTIONS, options };
}

export function changeFormValues(form, field, value) {
  return change(form, field, value);
}

export function removeArrayFormValues(form, field, index) {
  return arrayRemove(form, field, index);
}

export function savePrintTemplate(data) {
  return { type: 'SAVE_PRINT_TEMPLATE', data };
}

export function getPrintTemplateForEdit(id) {
  return { type: 'FETCH_PRINT_TEMPLATE_FOR_EDIT', id };
}

export function deletePrintTemplate(id) {
  return { type: 'DELETE_PRINT_TEMPLATE', id };
}

export function previewPrintTemplate(payload) {
  return { type: 'PREVIEW_PRINT_TEMPLATE', payload };
}

export function fetchPrintTemplateList( filters, silent ) {
  return { type: 'FETCH_TEMPLATE_LIST', filters, silent };
}

export function fetchJobList(filters, silent) {
  return { type: 'FETCH_LIST_JOB', filters, silent };
}

export function viewJobDetails(id) {
  return { type: 'VIEW_JOB_DETAILS', id };
}

export function fetchSystemNotesList(filters) {
  return { type: 'FETCH_LIST_SYSTEM_NOTES', filters };
}

export function saveLoyaltyRedemption(data) {
  return { type: 'SAVE_LOYALTY_REDEMPTION', data };
}

export function deleteLoyaltyRedemption(id) {
  return { type: 'DELETE_LOYALTY_REDEMPTION', id };
}

export function fetchLoyaltyRedemption(id) {
  return { type: 'FETCH_LOYALTY_REDEMPTION', id };
}

export function fetchLoyaltyRedemptionList(silent, filters) {
  return { type: 'FETCH_LIST_LOYALTY_REDEMPTION', filters, silent };
}

export function saveCsvExport(data) {
  return { type: 'SAVE_CSV_EXPORT', data };
}

export function saveExportCsvExport(data) {
  return { type: 'SAVE_EXPORT_CSV_EXPORT', data };
}

export function getCsvExportForEdit(id) {
  return { type: 'FETCH_CSV_EXPORT_FOR_EDIT', id };
}

export function fetchCsvExportList(filters, silent) {
  return { type: 'FETCH_LIST_CSV_EXPORT', filters, silent };
}

export function deleteCsvExport(id) {
  return { type: 'DELETE_CSV_EXPORT', id };
}

export function exportCsvRecord (data) {
  return { type: 'EXPORT_CSV', payload: data };
}

export function fetchCsvExportHistory( reference_id ) {
  return { type: 'FETCH_RUN_HISTORY', reference_id };
}

export function getPriceBookItemLocation(key, payload) {
  return { type: 'GET_PRICE_BOOK_ITEM_LOCATION', key, payload };
}

export function getRoleEmployees(key, payload) {
  return { type: 'GET_ROLE_EMPLOYEES', key, payload };
}

export function getCustomerSaleTransactions(key, payload) {
  return { type: 'GET_CUSTOMER_SALE_TRANSACTIONS', key, payload };
}

export function getCustomerPayments(key, payload) {
  return { type: 'GET_CUSTOMER_PAYMENTS', key, payload };
}

export function getItemHotkeyGroups(key, payload) {
  return { type: 'GET_ITEM_HOTKEY_GROUPS', key, payload };
}

export function fetchCustomFieldList(filters, silent) {
  return { type: 'FETCH_LIST_CUSTOM_FIELD', filters, silent };
}

export function fetchCustomFieldForEdit(id) {
  return { type: 'FETCH_CUSTOM_FIELD_FOR_EDIT', id };
}

export function saveCustomField(data) {
  return { type: 'SAVE_CUSTOM_FIELD', data };
}

export function deleteCustomField(id) {
  return { type: 'DELETE_CUSTOM_FIELD', id };
}

export function getCustomFieldTabSettingLines(removedAppliedTo, tabSettings) {
  return { type: 'GET_CUSTOM_FIELD_TAB_SETTING_LINES', payload: { removedAppliedTo, tabSettings } };
}

export function fetchCustomFormList(filters, silent) {
  return { type: 'FETCH_LIST_CUSTOM_FORM', filters, silent };
}

export function fetchCustomFormForEdit(id) {
  return { type: 'FETCH_CUSTOM_FORM_FOR_EDIT', id };
}

export function saveCustomForm(data) {
  return { type: 'SAVE_CUSTOM_FORM', data };
}

export function deleteCustomForm(id) {
  return { type: 'DELETE_CUSTOM_FORM', id };
}

export function getCustomFormTabSettingLines(removedAppliedTo, tabSettings) {
  return { type: 'GET_CUSTOM_FORM_TAB_SETTING_LINES', payload: { removedAppliedTo, tabSettings } };
}

export function fetchCustomTabList(filters, silent) {
  return { type: 'FETCH_LIST_CUSTOM_TAB', filters, silent };
}

export function fetchCustomTabForEdit(id) {
  return { type: 'FETCH_CUSTOM_TAB_FOR_EDIT', id };
}

export function saveCustomTab(data) {
  return { type: 'SAVE_CUSTOM_TAB', data };
}

export function deleteCustomTab(id) {
  return { type: 'DELETE_CUSTOM_TAB', id };
}

export function getCustomTabCustomFields(key, payload) {
  return { type: 'GET_CUSTOM_TAB_CUSTOM_FIELDS', key, payload };
}

export function getCustomTabCustomForms(key, payload) {
  return { type: 'GET_CUSTOM_TAB_CUSTOM_FORMS', key, payload };
}

export function fetchListRecord(filters, silent) {
  return { type: 'FETCH_LIST_RECORD', filters, silent };
}

export function fetchListForEdit(id) {
  return { type: 'FETCH_LIST_FOR_EDIT', id };
}

export function saveList(data) {
  return { type: 'SAVE_LIST', data };
}

export function deleteList(id) {
  return { type: 'DELETE_LIST', id };
}

export function saveApiCredential(data) {
  return { type: 'SAVE_API_CREDENTIAL', data };
}

export function getApiCredentialForEdit(id) {
  return { type: 'FETCH_API_CREDENTIAL_FOR_EDIT', id };
}

export function fetchApiCredentialList(filters, silent) {
  return { type: 'FETCH_API_CREDENTIAL_LIST', filters, silent };
}

export function deleteApiCredential(id) {
  return { type: 'DELETE_API_CREDENTIAL', id };
}

export function savePriceGroup(data) {
  return { type: 'SAVE_PRICE_GROUP', data };
}

export function getPriceGroupById(id) {
  return { type: 'FETCH_PRICE_GROUP_BY_ID', id };
}

export function deletePriceGroup(id) {
  return { type: 'DELETE_PRICE_GROUP_FROM_LIST', id };
}

export function fetchPriceGroupList(filters, silent) {
  return { type: 'FETCH_LIST_PRICE_GROUP', filters, silent };
}

export function saveUnitOfMeasureType(data) {
  return { type: 'SAVE_UNIT_OF_MEASURE_TYPE', data };
}

export function getUnitOfMeasureTypeById(id) {
  return { type: 'FETCH_UNIT_OF_MEASURE_TYPE_BY_ID', id };
}

export function deleteUnitOfMeasureType(id) {
  return { type: 'DELETE_UNIT_OF_MEASURE_TYPE_FROM_LIST', id };
}

export function fetchUnitOfMeasureTypeList(filters, silent) {
  return { type: 'FETCH_LIST_UNIT_OF_MEASURE_TYPE', filters, silent };
}

export function fetchItemGroupPriceList(filters, silent) {
  return { type: 'FETCH_LIST_ITEM_GROUP_PRICE', filters, silent };
}

export function getItemGroupPriceById(id) {
  return { type: 'FETCH_ITEM_GROUP_PRICE_BY_ID', id };
}

export function saveItemGroupPrice(data) {
  return { type: 'SAVE_ITEM_GROUP_PRICE', data };
}

export function deleteItemGroupPrice(id) {
  return { type: 'DELETE_ITEM_GROUP_PRICE', id };
}

export function ereceiptSale(transactionId) {
  return { type: ActionType.ERECEIPT_SALE, payload: transactionId };
}

export function saveEvent(data) {
  return { type: 'SAVE_EVENT', data };
}

export function deleteEvent(id) {
  return { type: 'DELETE_EVENT', id };
}

export function fetchEvent(id) {
  return { type: 'FETCH_EVENT', id };
}

export function fetchEventList(silent, filters) {
  return { type: 'FETCH_LIST_EVENT', filters, silent };
}

export function getEventLogs(key, payload) {
  return { type: 'GET_EVENT_LOGS', key, payload };
}

export function saveShortcut(data) {
  return { type: 'SAVE_SHORTCUT', data };
}

export function deleteShortcut(id) {
  return { type: 'DELETE_SHORTCUT', id };
}

export function fetchShortcut(id) {
  return { type: 'FETCH_SHORTCUT', id };
}

export function fetchShortcutList(silent, filters) {
  return { type: 'FETCH_LIST_SHORTCUT', filters, silent };
}

export function saveShortcutGroup(data) {
  return { type: 'SAVE_SHORTCUT_GROUP', data };
}

export function deleteShortcutGroup(id) {
  return { type: 'DELETE_SHORTCUT_GROUP', id };
}

export function fetchShortcutGroup(id) {
  return { type: 'FETCH_SHORTCUT_GROUP', id };
}

export function fetchShortcutGroupList(silent, filters) {
  return { type: 'FETCH_LIST_SHORTCUT_GROUP', filters, silent };
}

export function exportPrintTransaction(id, docType) {
  return { type: SagasType.EXPORT_PRINT_TRANSACTION, payload: { id, docType } };
}

export function exportEmailTransaction(payload) {
  return { type: SagasType.EXPORT_EMAIL_TRANSACTION, payload };
}

export function saveBudget(data) {
  return { type: 'SAVE_BUDGET', data };
}

export function deleteBudget(id) {
  return { type: 'DELETE_BUDGET', id };
}

export function fetchBudget(id) {
  return { type: 'FETCH_BUDGET', id };
}

export function fetchBudgetList(silent, filters) {
  return { type: 'FETCH_LIST_BUDGET', filters, silent };
}